module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEKSURBVHgBpVKLDYMgEL10gm4gI+gGuIGj6AS6QdnAbqIb0A1wA92A3l2BIGJr0pc8SeDefd4JcIREPpAGaR01ckQK+IK7E9offLjYg1hfEMcd7ZIcKjdNY40xTCnlWScMkauitWYhJZqm6awTCc6cXWXCOI7WQynFZ6YTBenswzBw8LqufNIIHm3bpgnMDT9lbIYQ4uPq/eNRXdcwz/PuLQ6/pTdFUfC5bVsQdl0Hy7LkEgAlWOILX7mqKhbxjFqz2CeP8AJnRJiLZqe5y7LkuVEYPKC3xANaAK8iXMaGYTe273sbI0kgfCuhC7+yHOgNkhWG0eHPX9knURfEKieOIZDPpCPjhDINfgMHcRtL91kv5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/social/tiktok.png
// module id = ZWk2
// module chunks = 31